export default __webpack_public_path__ + "static/media/IMG_2119.29f8c905.jpg";